module.exports = __webpack_public_path__ + "img/logo-um-fvv.c793e48c.png";